import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FooterComponent } from 'src/app/footer/footer.component';
import { GetStartedTodayComponent } from 'src/app/get-started-today/get-started-today.component';
import { HeaderComponent } from 'src/app/header/header.component';
import { JsonLdService } from 'src/app/services/json-ld.service';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-clay',
  templateUrl: './clay.html',
  styleUrls: ['./clay.css', "../mailchimp/mailchimp.component.css"],
  imports: [HeaderComponent, GetStartedTodayComponent, FooterComponent, RouterModule],
})
export class Clay implements OnInit, AfterViewInit {

  userDetail: any;
  isBrowser: boolean;
  copyButtonText = "Click to Copy"

  constructor(
    private jsonldservice: JsonLdService,
    private toaster: ToasterService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    const clayJson = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://kudoshub.com/#organization",
          "name": "KudosHub",
          "url": "https://kudoshub.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://kudoshub.com/theme/images/og-images/logo.webp",
            "thumbnailUrl": "https://kudoshub.com/theme/images/og-images/logo.webp",
            "width": 160,
            "height": 160
          },
          "sameAs": [
            "https://www.facebook.com/KudosHub/",
            "https://www.linkedin.com/company/kudoshub/",
            "https://www.youtube.com/channel/UCN_L5eAxhiRYcjMd60y4gwg",
            "https://x.com/KudosHub"
          ],
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Kalidas Road",
            "addressLocality": "Inder Vihar",
            "addressRegion": "Dehradun",
            "postalCode": "248001",
            "addressCountry": "IN"
          },
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+91-9997100097",
              "contactType": "customer support",
              "availableLanguage": "en"
            }
          ]
        },
        {
          "@type": "WebPage",
          "@id": "https://kudoshub.com/integrations/clay/#webpage",
          "url": "https://kudoshub.com/integrations/clay",
          "name": "Connect KudosHub with Clay.com to Automate Email Validation",
          "description": "Automate real-time email validation inside Clay.com with KudosHub. Score emails, eliminate bounces, and improve deliverability to maintain lead quality.",
          "inLanguage": "en",
          "isPartOf": {
            "@id": "https://kudoshub.com/#website"
          },
          "datePublished": "2025-11-21T10:30:00+05:30",
          "dateModified": "2025-11-21T10:30:00+05:30"
        },
        {
          "@type": "Service",
          "@id": "https://kudoshub.com/integrations/clay/#service",
          "name": "KudosHub Email Validation using clay integration",
          "serviceType": "Clay Email Validation and Scoring Integration",
          "description": "KudosHub Email Validation Integration for Clay provides real-time verification, AI email scoring, and secure API automation to keep Clay workflows clean, accurate, and ready for efficient outreach.",
          "offers": {
            "@type": "AggregateOffer",
            "url": "https://kudoshub.com/email-validation/#pricing",
            "priceCurrency": "USD",
            "lowPrice": "0",
            "highPrice": "0.0034",
            "offerCount": 2,
            "offers": [
              {
                "@type": "Offer",
                "name": "30-Day Free Trial (100 daily credits)",
                "description": "3,000 complimentary email validations (100 per day) for new users.",
                "price": "0",
                "priceCurrency": "USD",
                "url": "https://kudoshub.com/signup",
                "availability": "https://schema.org/InStock",
                "priceSpecification": {
                  "@type": "UnitPriceSpecification",
                  "unitText": "email validations",
                  "price": "0",
                  "unitCode": "C62"
                }
              },
              {
                "@type": "Offer",
                "name": "Commercial Volume Pricing",
                "description": "Per-validation cost drops from $0.0034 (low volume) down to $0.00055 (high volume). Enterprise quotes available.",
                "url": "https://kudoshub.com/pricing#commercial",
                "availability": "https://schema.org/InStock",
                "priceSpecification": {
                  "@type": "UnitPriceSpecification",
                  "unitText": "email validations",
                  "priceCurrency": "USD",
                  "minPrice": "0.00055",
                  "maxPrice": "0.0034"
                }
              }
            ]
          },
          "provider": {
            "@id": "https://kudoshub.com/#organization"
          },
          "url": "https://kudoshub.com/integrations/clay",
          "areaServed": "Worldwide"
        }
      ]
    };
    const breadcrumb = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "@id": "https://kudoshub.com/integrations/clay/#breadcrumb",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://kudoshub.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Integrations",
          "item": "https://kudoshub.com/integrations/"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Clay Integration",
          "item": "https://kudoshub.com/integrations/clay/"
        }
      ]
    };
    const faq = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "@id": "https://kudoshub.com/integrations#faq",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What are KudosHub integrations and how to connect with other tools?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub integrations let you connect your email validation engine with CRMs, ESPs, and automation tools. You can integrate using APIs, Zapier, or native connections. Once linked, your email lists are validated automatically, keeping your data accurate and your campaigns performing with 99% accuracy."
          }
        },
        {
          "@type": "Question",
          "name": "Which platforms can I connect with KudosHub?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub integrates with popular CRMs, ESPs, and automation tools, including HubSpot, Clay, Apollo, Mailchimp, and Zapier. You can also connect with custom platforms through our REST API or webhook integrations to automate validation directly inside your existing workflow."
          }
        },
        {
          "@type": "Question",
          "name": "How do I integrate KudosHub with Clay for email validation?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can integrate KudosHub with Clay by creating an HTTP API action, adding the KudosHub validation endpoint, mapping your email column, and authenticating with your API key. Clay will send each email to KudosHub and return a validation result directly into your table."
          }
        },
        {
          "@type": "Question",
          "name": "How can I use KudosHub’s real-time email verification inside Clay sequences?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Add the KudosHub validation step inside your Clay sequence workflow. Each new or updated contact will be verified instantly, allowing you to filter invalid emails, protect deliverability, and keep your outreach sequences clean before sending any automated messages."
          }
        },
        {
          "@type": "Question",
          "name": "How does KudosHub’s AI email scoring work within Clay automation?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub uses an AI model to score each email by quality and engagement potential. When you enable scoring in the Clay API request, Clay receives a score value that helps you prioritize strong leads, segment contacts, and remove low-quality addresses from your automated workflows."
          }
        },
        {
          "@type": "Question",
          "name": "How do I set up my KudosHub API credentials in Clay for integration?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Generate your API key inside the KudosHub dashboard. Add it to the Clay HTTP API request under query parameters as 'api-key'. This key authorizes Clay to send validation or scoring requests to KudosHub securely through the validation endpoint."
          }
        },
        {
          "@type": "Question",
          "name": "How to troubleshoot a failed data sync between Clay and KudosHub?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "First check if your API key is correct and active. Then confirm your email field is mapped properly and the request method is set to POST. If Clay returns an error, verify your endpoint URL and try a test request. Re-run the action after fixing the configuration."
          }
        },
        {
          "@type": "Question",
          "name": "What are the deliverability benefits of integrating KudosHub with Clay?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub removes invalid, risky, and disposable emails before they enter your Clay sequences. This reduces bounce rates, protects sender reputation, and improves inbox placement. Clean contacts allow your outreach campaigns to perform better and deliver stronger engagement."
          }
        },
        {
          "@type": "Question",
          "name": "What is the difference between using KudosHub vs. Clay’s built-in email validation?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Clay provides basic checks, while KudosHub offers advanced validation with sixteen plus verification layers, AI email scoring, spam trap detection, and detailed status codes. This gives Clay users deeper accuracy, stronger deliverability protection, and better lead filtering."
          }
        },
        {
          "@type": "Question",
          "name": "How can I remove disposable, spam trap, and catch-all emails in Clay using KudosHub?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Use the KudosHub HTTP API action inside Clay. Each email is checked in real time and flagged as disposable, spam trap, catch-all, invalid, or safe. You can filter or remove risky contacts directly from your Clay table based on these returned values."
          }
        },
        {
          "@type": "Question",
          "name": "How does KudosHub improve CRM hygiene in Clay workflows?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub verifies each email before it enters your Clay automations, removes risky contacts, and updates status fields in real time. This prevents data decay, reduces manual cleanup, and ensures your CRM stays accurate and ready for reliable outreach."
          }
        },
        {
          "@type": "Question",
          "name": "How often should I run KudosHub email validation inside Clay tables?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Run validation whenever you add new leads, import data, or update existing records. For long-term hygiene, schedule periodic re-validation to prevent list decay and maintain accurate email quality inside Clay over time."
          }
        },
        {
          "@type": "Question",
          "name": "What is the cost or pricing model for using KudosHub with Clay integration?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub uses a simple pay-per-validation model. Each email validation consumes 1 credit. If you enable AI scoring, it uses 2 credits—one for validation and one for scoring. There are no additional Clay integration fees."
          }
        },
        {
          "@type": "Question",
          "name": "How do I run bulk email validation inside Clay using KudosHub?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Select your email column, apply the KudosHub HTTP API action, and run the action on your entire table or selected rows. Clay will batch each request and return validation results for all emails directly into your table."
          }
        },
        {
          "@type": "Question",
          "name": "What data fields does KudosHub return inside Clay after email validation?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "KudosHub returns key data fields including email status, risk level, deliverability outcome, confidence score, AI quality score, reason codes, and metadata indicators such as disposable, catch-all, or spam trap detection."
          }
        }
      ]
    };

    this.jsonldservice.addJsonLd(clayJson, breadcrumb, faq);
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      const hash = window.location.hash;
      if (!hash) return;

      const id = hash.slice(1);
      
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }

  setUserDetails(data) {
    this.userDetail = data.userDetail;
  }

  async copyToClipboard(event: Event) {
    event.preventDefault(); // stops navigation

    if (!isPlatformBrowser(this.platformId)) return;

    await navigator.clipboard.writeText("https://api.kudoshub.com/v1/validate");
    this.toaster.show(
      "success",
      "Well Done",
      "Link Copied Successfully"
    );
  }
}
